import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { useSelector, connect } from 'react-redux';
import { cloneDeep } from 'lodash';
import { Button, Tabs, Tab } from 'react-bootstrap/lib';
// @ts-ignore @TODO: add types for package
import { Confirm } from 'react-confirm-bootstrap';
import { Dimmer, Loader } from 'semantic-ui-react';
import { FinanceType } from '@upstart/harmony/lib/legos/constants';
import { Condition } from '@upstart/harmony/lib/constants';
import TiersContainer from './Tiers/components/TiersContainer';
import { useAprConfig, AprConfigResultProps } from './Tiers/useAprConfig';
import { dealerRequest } from '../../redux/dealers/actions';
import ErrorMessage from '../ErrorMessage';

// @ts-ignore
function AprConfig(props) {
  const { clientType, actions } = props;
  // @ts-ignore
  const dealer: Dealer = useSelector((state: any) => state.dealers.dealer);
  const onePayLeaseEnabled = dealer.desking?.enableOnePayLease || false;

  const [condition, setCondition] = useState(Condition.NEW);

  const newAprConfig = useAprConfig({
    dealerId: dealer.id,
    section: {
      type: clientType,
      condition: Condition.NEW,
    },
    onePayLeaseEnabled,
  });

  const usedAprConfig = useAprConfig({
    dealerId: dealer.id,
    section: {
      type: clientType,
      condition: Condition.USED,
    },
  });

  const onCopyConfiguration = (from: Condition, to: Condition) => {
    if (from === Condition.CPO || to === Condition.CPO || from === to) return;
    const fromAprConfig =
      from === Condition.USED ? usedAprConfig : newAprConfig;
    const toAprConfig = to === Condition.USED ? usedAprConfig : newAprConfig;

    if (!fromAprConfig.tieredAprConfig || !toAprConfig.tieredAprConfig) return;

    const { tieredAprConfig } = fromAprConfig;

    const { enabled, tiers, options, pricing } = tieredAprConfig;
    const clone = {
      enabled,
      options: cloneDeep(options),
      tiers: {
        [FinanceType.LEASE]: [],
        ...(toAprConfig?.tieredAprConfig?.tiers || {}),
        [FinanceType.PURCHASE]: cloneDeep(tiers[FinanceType.PURCHASE]),
      },
      pricing: {
        [FinanceType.LEASE]: {
          ...(toAprConfig?.tieredAprConfig?.pricing.lease || {
            terms: [],
            pricing: [],
          }),
        },
        [FinanceType.PURCHASE]: cloneDeep(pricing[FinanceType.PURCHASE]),
      },
    };
    toAprConfig.copy(clone);
  };

  const onRevert = () => {
    newAprConfig.revert();
    usedAprConfig.revert();
  };

  const onSave = async () => {
    // We should await for the result and then we need to refresh the dealer to get the updated dealer
    // with pricing config. This will help for validating front end errors.
    await newAprConfig.save();
    await usedAprConfig.save();
    actions.dealerRequest({ dealerId: dealer.id });
  };

  const getOppositeCondition = (type: Condition) =>
    type === Condition.NEW ? Condition.USED : Condition.NEW;

  const renderTab = (
    tabCondition: Condition.USED | Condition.NEW,
    aprConfigResult: AprConfigResultProps,
  ) => {
    // Get opposite condition for copy button
    const oppositeCondition = getOppositeCondition(tabCondition);
    const { error } = aprConfigResult;

    return (
      <Tab eventKey={tabCondition} title={tabCondition}>
        {error && <ErrorMessage error={error} />}
        <Button
          onClick={() => onCopyConfiguration(oppositeCondition, tabCondition)}
        >
          <i className="glyphicon glyphicon-duplicate" />
          &nbsp; Copy configuration from {oppositeCondition} Cars
        </Button>
        <hr />
        {newAprConfig.loading || usedAprConfig.loading ? (
          <Dimmer active inverted>
            <Loader inverted content="Loading" />
          </Dimmer>
        ) : (
          <TiersContainer {...aprConfigResult} condition={tabCondition} />
        )}
        <div className="row shadow-footer">
          <div />
        </div>
        <div className="row save-footer">
          <div className="col-sm-12">
            <Confirm
              onConfirm={() => onSave()}
              body="Are you sure you want to save changes for New &amp; Used?"
              confirmText="Save"
              title="Save Changes"
              confirmBSStyle="primary"
            >
              <Button
                title={
                  !usedAprConfig.validationResult.success ||
                  !newAprConfig.validationResult.success
                    ? 'Please resolve validation errors'
                    : ''
                }
                disabled={
                  !usedAprConfig.validationResult.success ||
                  !newAprConfig.validationResult.success
                }
                bsStyle="primary"
              >
                Save Changes
              </Button>
            </Confirm>
            <Confirm
              onConfirm={() => onRevert()}
              body="Are you sure you want to revert changes for New &amp; Used?"
              confirmText="Revert"
              title="Revert Changes"
            >
              <Button>Revert Changes</Button>
            </Confirm>
          </div>
        </div>
      </Tab>
    );
  };

  return (
    <div className="tabbed-page-container">
      <Tabs
        id="apr-config-tabs"
        mountOnEnter
        unmountOnExit
        activeKey={condition}
        // @ts-ignore
        onSelect={setCondition}
      >
        {renderTab(Condition.NEW, newAprConfig)}
        {renderTab(Condition.USED, usedAprConfig)}
      </Tabs>
    </div>
  );
}

AprConfig.defaultProps = {
  // Custom tag name allows nesting <Form> components
  tagName: 'div',
};

AprConfig.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  tagName: PropTypes.string,
  clientType: PropTypes.string,
  actions: PropTypes.object,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any) => ({
  actions: bindActionCreators({ dealerRequest }, dispatch),
});

// export default AprConfig;
export default connect(null, mapDispatchToProps)(AprConfig);
